import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import DrawCloseIcon from '../Icon/DrawCloseIcon'

export interface DrawRightProps {
  open: boolean
  children: JSX.Element[] | JSX.Element
  title: string
  onClose: () => void
}

function DrawRight({ open, children, title, onClose }: DrawRightProps) {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as='div' className='relative z-[9999]' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-[#000000c5]' />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter='transform transition ease-in-out duration-500'
          enterFrom='translate-x-full'
          enterTo='translate-x-0'
          leave='transform transition ease-in-out duration-500'
          leaveFrom='translate-x-0'
          leaveTo='translate-x-full'
        >
          <Dialog.Panel className='pointer-events-auto fixed right-0 top-0 z-50 flex h-full w-[400px] overflow-hidden bg-white pb-6 shadow-md'>
            <div className='w-full'>
              <div className='h-[72px] px-5 pt-5'>
                <Dialog.Title as='h2' className='text-xl font-bold'>
                  {title}
                </Dialog.Title>
                <button
                  onClick={onClose}
                  className='absolute right-3 top-5 z-10 cursor-pointer outline-none'
                >
                  <DrawCloseIcon />
                </button>
              </div>
              <div className='hiddenScrollBar h-full overflow-y-auto px-5'>
                {children}
              </div>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  )
}

export default DrawRight
